import Textbox from '../components/Textbox'
import Image from '../components/Image'

const imageDimensions = 111
const smallImageDimensions = (imageDimensions * 2 - 5) / 3 // imageDimensions * 2 - 10 from separations / 3

const singleImageDimensions = {
  height: 200,
  width: 227,
}

const textBoxWidth = {
  subtitle: 75,
  paragraph: 230,
  title: 100,
  title_150: 150,
  impactBenefits: 600,
}

const textBoxHeight = {
  text: 20,
  name: 30,
  title: 20,
  paragraph: 200,
  impactBenefits: 100,
}

const row1 = 15
const row2 = row1 + 35
const row3 = row2 + 40
const row4 = row3 + 18
const row5 = row4 + 18
const row6 = row5 + 35
const row7 = row6 + 15
const row8 = row7 + textBoxHeight.paragraph + 10
const row9 = row8 + 25
const row10 = row9 + 18
const row11 = row10 + 25
const row12 = row11 + 15
const row13 = 510

const columnSeparation = 23

// Main columns
const columnA = 12
const columnB = columnA + textBoxWidth.title + columnSeparation
const columnD = columnB + textBoxWidth.title + columnSeparation
const columnE = columnD + textBoxWidth.title_150 + columnSeparation
const columnF = columnE + 55
const columnG = columnE + textBoxWidth.title_150 + columnSeparation
const columnJ = columnG + textBoxWidth.title_150 + columnSeparation

// Complementary columns
const columnC = columnA + textBoxWidth.paragraph + 3
const columnH = columnF + textBoxWidth.paragraph + 3
const columnI = columnH + 5
const columnK = columnJ + 100

// Image position

const imagePosition = {
  1: {
    top: row7,
    imageDimension: imageDimensions,
  },

  2: {
    left: imageDimensions + 5,
    top: row7,
    imageDimension: imageDimensions,
  },

  3: {
    top: row7 + imageDimensions + 5,
    imageDimension: smallImageDimensions,
  },

  4: {
    left: smallImageDimensions + 5,
    top: row7 + imageDimensions + 5,
    imageDimension: smallImageDimensions,
  },

  5: {
    left: smallImageDimensions * 2 + 10,
    top: row7 + imageDimensions + 5,
    imageDimension: smallImageDimensions,
  },
}

const fontColor = {
  title: '#234EA3',
  text: '#1E1E1E',
}

const fontSize = {
  title: 12,
  subtitle: 12,
  name: 18,
  text: 9.5,
}

function buildRevImages(revMedia, initialColumn) {
  return revMedia.forEach((media, index) =>
    new Image({
      left: initialColumn + (imagePosition[index + 1]?.left ?? 0),
      top: imagePosition[index + 1]?.top,
      width: imagePosition[index + 1]?.imageDimension,
      height: imagePosition[index + 1]?.imageDimension,
    }).add(media)
  )
}

export default {
  async add(data) {
    return this.addTo__default(data)
  },

  async addTo__default(data) {
    try {
      const slideIndex = await new Textbox().getSelectedSlideIndex()

      // ////////// ROW 1:

      // Type
      await new Textbox({
        left: columnA,
        top: row1,
        width: textBoxWidth.title,
        height: textBoxHeight.text,
        fontSize: fontSize.text,
        fontColor: fontColor.text,
      }).add(slideIndex, data.type)
      // Status
      await new Textbox({
        left: columnB,
        top: row1,
        width: textBoxWidth.title,
        height: textBoxHeight.text,
        fontSize: fontSize.text,
        fontColor: fontColor.text,
      }).add(slideIndex, data.status)
      // Created at
      await new Textbox({
        left: columnD,
        top: row1,
        width: textBoxWidth.title_150,
        height: textBoxHeight.text,
        fontSize: fontSize.text,
        fontColor: fontColor.text,
      }).add(slideIndex, data.createdAt)
      // Completed at
      await new Textbox({
        left: columnE,
        top: row1,
        width: textBoxWidth.title_150,
        height: textBoxHeight.text,
        fontSize: fontSize.text,
        fontColor: fontColor.text,
      }).add(slideIndex, data.completedAt)
      // Implemented at
      await new Textbox({
        left: columnG,
        top: row1,
        width: textBoxWidth.title_150,
        height: textBoxHeight.text,
        fontSize: fontSize.text,
        fontColor: fontColor.text,
      }).add(slideIndex, data.implementedAt)
      // Impact validated at
      await new Textbox({
        left: columnJ,
        top: row1,
        width: textBoxWidth.title_150,
        height: textBoxHeight.text,
        fontSize: fontSize.text,
        fontColor: fontColor.text,
      }).add(slideIndex, data.impactValidatedAt)

      // ////////// ROW 2:

      // Name
      await new Textbox({
        left: columnA,
        top: row2,
        width: 850,
        height: textBoxHeight.name,
        fontSize: fontSize.name,
        fontColor: fontColor.text,
      }).add(slideIndex, data.name)

      // ////////// ROW 3:

      // Site
      await new Textbox({
        left: columnA,
        top: row3,
        width: 400,
        height: textBoxHeight.text,
        fontSize: fontSize.text,
        fontColor: fontColor.text,
      }).add(slideIndex, data.site)
      // Country
      await new Textbox({
        left: columnF,
        top: row3,
        width: 200,
        height: textBoxHeight.text,
        fontSize: fontSize.text,
        fontColor: fontColor.text,
      }).add(slideIndex, data.country)

      // ////////// ROW 4:

      // Author
      await new Textbox({
        left: columnA,
        top: row4,
        width: 250,
        height: textBoxHeight.text,
        fontSize: fontSize.text,
        fontColor: fontColor.text,
      }).add(slideIndex, data.author)
      // Coach
      if (data.coach) {
        await new Textbox({
          left: columnF,
          top: row4,
          width: 350,
          height: textBoxHeight.text,
          fontSize: fontSize.text,
          fontColor: fontColor.text,
        }).add(slideIndex, data.coach)
      }

      // ////////// ROW 5:

      // Team
      if (data.team) {
        await new Textbox({
          left: columnA,
          top: row5,
          width: 350,
          height: textBoxHeight.text,
          fontSize: fontSize.text,
          fontColor: fontColor.text,
        }).add(slideIndex, data.team)
      }
      // Categories
      if (data.team) {
        await new Textbox({
          left: columnF,
          top: row5,
          width: 430,
          height: textBoxHeight.text,
          fontSize: fontSize.text,
          fontColor: fontColor.text,
        }).add(slideIndex, data.categories)
      }

      // ////////// ROW 6:

      // // Problem
      await new Textbox({
        left: columnA,
        top: row6,
        width: textBoxWidth.subtitle,
        height: textBoxHeight.text,
        fontSize: fontSize.title,
        fontColor: fontColor.title,
      }).add(slideIndex, data.problemTitle)

      // Solution
      await new Textbox({
        left: columnF,
        top: row6,
        width: textBoxWidth.subtitle,
        height: textBoxHeight.text,
        fontSize: fontSize.title,
        fontColor: fontColor.title,
      }).add(slideIndex, data.solutionTitle)

      // ////////// ROW 7:

      // // Problem
      if (data.problem) {
        await new Textbox({
          left: columnA,
          top: row7,
          width: textBoxWidth.paragraph,
          height: textBoxHeight.paragraph,
          fontSize: fontSize.text,
          fontColor: fontColor.text,
          align: 'justify',
        }).add(slideIndex, data.problem)
      }
      // // Solution
      if (data.solution) {
        await new Textbox({
          left: columnF,
          top: row7,
          width: textBoxWidth.paragraph,
          height: textBoxHeight.paragraph,
          align: 'justify',
          fontSize: fontSize.text,
          fontColor: fontColor.text,
        }).add(slideIndex, data.solution)
      }

      // ////////// ROW 8:

      // Impact
      await new Textbox({
        left: columnA,
        top: row8,
        width: textBoxWidth.subtitle,
        height: textBoxHeight.text,
        fontSize: fontSize.title,
        fontColor: fontColor.title,
      }).add(slideIndex, data.impactTitle)

      // ////////// ROW 9:

      // Estimate Benefits
      await new Textbox({
        left: columnA,
        top: row9,
        width: 250,
        height: textBoxHeight.text,
        fontSize: fontSize.text,
        fontColor: fontColor.text,
        fontWeight: 'bold',
      }).add(slideIndex, data.impactBenefitsTitle)

      await new Textbox({
        left: columnI,
        top: row9,
        width: 150,
        height: textBoxHeight.text,
        fontSize: fontSize.text,
        fontColor: fontColor.text,
        fontWeight: 'bold',
      }).add(slideIndex, data.totalImpactValidatedTitle)

      // ////////// ROW 10:

      if (data.impactBenefits) {
        await new Textbox({
          left: columnA,
          top: row10,
          width: textBoxWidth.impactBenefits,
          height: textBoxHeight.impactBenefits,
          align: 'justify',
          fontSize: fontSize.text,
          fontColor: fontColor.text,
        }).add(slideIndex, data.impactBenefits)
      } else {
        await new Textbox({
          left: columnA,
          top: row10,
          width: textBoxWidth.impactBenefits,
          height: textBoxHeight.text,
          align: 'left',
          fontSize: fontSize.text,
          fontColor: '#718096',
        }).add(slideIndex, data.emptyImpactBenefits)
      }

      if (data.totalImpact) {
        await new Textbox({
          left: columnI,
          top: row10,
          width: 200,
          height: textBoxHeight.text,
          fontSize: fontSize.name,
          fontColor: fontColor.text,
        }).add(slideIndex, data.totalImpact)
      }

      // ////////// ROW 11:

      // // Time frame
      await new Textbox({
        left: columnI,
        top: row11,
        width: 180,
        height: textBoxHeight.text,
        fontSize: fontSize.text,
        fontColor: fontColor.text,
      }).add(slideIndex, data.impactTimeFrameTitle)

      // ////////// ROW 12:
      await new Textbox({
        left: columnI,
        top: row12,
        width: 150,
        height: textBoxHeight.text,
        fontSize: fontSize.text,
        fontColor: fontColor.text,
      }).add(slideIndex, data.impactTimeFrame)

      if (data?.revMedia?.[0]) {
        data.revMedia?.length > 1
          ? buildRevImages(data.revMedia, columnC)
          : new Image({
              left: columnC,
              top: row7,
              width: singleImageDimensions.width,
              height: singleImageDimensions.height,
            }).add(data.revMedia[0])
      }

      if (data?.solutionMedia?.[0]) {
        data.solutionMedia?.length > 1
          ? buildRevImages(data.solutionMedia, columnH)
          : new Image({
              left: columnH,
              top: row7,
              width: singleImageDimensions.width,
              height: singleImageDimensions.height,
            }).add(data.solutionMedia[0])
      }

      new Image({
        left: columnK,
        top: row13,
        width: 70,
        height: 20,
      }).add(data.logo)
    } catch (err) {
      console.log('error on try/catch', err)
    }
  },
}
